import HttpService from "./htttp.service";

class ClientsService {
  // ClientsEndpoint = process.env.API_URL;

  getClients = async () => {
    const getClients = "dash/clients";
    return await HttpService.get(getClients);
  };

  getSingleClient = async (id) => {
    const getSingleClients = `dash/clients/${id}`;
    return await HttpService.get(getSingleClients);
  };

  createClient = async (payload) => {
    const createClient = "dash/clients/new";
    return await HttpService.post(createClient, payload);
  };

  updateClient = async (id, payload) => {
    const updateClient = `dash/clients/${id}`;
    return await HttpService.put(updateClient, payload);
  };

  activateDeactivateDashClient = async (id, payload) => {
    const activateDeactivateDashClient = `dash/clients/active/${id}`;
    return await HttpService.put(activateDeactivateDashClient, payload);
  };
}

export default new ClientsService();
